import type { dynamicObj } from 'src/pages/assets';
import { objLen } from 'src/utils/general';

/**
 * New API response format:
 * {
 *   "success": true,
 *   "is_admin": false,
 *   "permissions": {
 *     "INVOICE": { "edit": 0, "delete": 1, "view": 0, ... },
 *     "CREDIT_NOTE": { ... }
 *   }
 * }
 */
// Reserved cache key holding the ids of the groups the current user belongs
// to. Populated by Acl.fetch() from getUserGroups() — NOT from this response:
// /access_controls/get_doc_type_permissions only returns groups that have
// doc-type permissions configured, not the groups the user is a member of.
// Underscore-prefixed so it can never collide with a document-type key.
export const USER_GROUP_IDS_KEY = '_user_group_ids';

export const Formatter = {
  formatServerAClsResponse: function (acls_data: dynamicObj) {
    if (!acls_data || objLen(acls_data) < 1) {
      return {};
    }

    const user_acls = {} as dynamicObj;

    // Set is_admin flag from API response
    user_acls.is_admin = acls_data.is_admin ?? false;

    // Copy permissions directly from new API format
    if (acls_data.permissions && typeof acls_data.permissions === 'object') {
      for (const [docKey, permissions] of Object.entries(acls_data.permissions)) {
        user_acls[docKey] = permissions;
      }
    }

    return user_acls;
  },
};
